import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, FlexBox, Icon, Text } from '@dixa/lib-shared-habla';
import { typography } from '@dixa/lib-shared-tokens';
import { memo } from 'react';
import { KeyboardKeyCombinations } from 'components/keyboard';
/**
 * Represents normalized item content that should be used in copilot actions
 * selection list
 */
export const CopilotSelectionListItemContent = memo(function CopilotSelectionListItemContent({ icon, title, keyCombinations, }) {
    return (_jsxs(FlexBox, Object.assign({ gap: "200" }, { children: [_jsx(Box, Object.assign({ flex: "0" }, { children: _jsx(Icon, { name: icon }) })), _jsx(Box, Object.assign({ flex: "1" }, { children: _jsx(Text.Paragraph, { children: title }) })), _jsx(Box, Object.assign({ flex: "0" }, { children: _jsx(Text.Paragraph, Object.assign({ as: "span", color: typography.color.tertiary }, { children: !!(keyCombinations === null || keyCombinations === void 0 ? void 0 : keyCombinations.length) && (_jsx(KeyboardKeyCombinations, { keyCombinations: keyCombinations })) })) }))] })));
});
